import Pro from './Pro';

export default Pro;
